import "./AddonCard.css"
import CmsHelper, {PickProgramPageHelper} from "../../../../Utilities/CmsHelpers";
import React from "react";
import {useCms} from "../../../../../context/CmsContext";

export default function AddonCard({addon}) {
    const {pickProgramData} = useCms();

    const pickAddons = PickProgramPageHelper.getPickAddons(PickProgramPageHelper.getPrograms(pickProgramData, CmsHelper.DEFAULT))?.addons;
    const cmsData = PickProgramPageHelper.getAddon(pickAddons, addon?.skuORQuickCode)[0]

    return !!cmsData &&
    <>
        <div className={"addon-card-container"}>
            <div className={"content-wrapper"}>
                <img src={cmsData?.icon?.url} alt={`${addon.skuORQuickCode} icon`}/>
                <div>
                    <span className={"title"}>{cmsData?.title}</span>
                    <span className={"subtitle"}>{cmsData?.description}</span>
                </div>
            </div>
            <div className={"price-wrapper"}>
                {(cmsData?.oldPriceAfterPrice ||
                        cmsData?.oldPriceBeforePrice ||
                        cmsData?.oldPricePrice) &&
                    <div className={"old-price"}>
                        {!!cmsData?.oldPriceBeforePrice &&
                            <span className={"old-price-before"}>{cmsData?.oldPriceBeforePrice}</span>
                        }
                        {!!cmsData?.oldPricePrice &&
                            <>
                                <span className={"old-price-price"}>{cmsData?.oldPricePrice}</span>
                                <div className={"crossed-line"} />
                            </>
                        }
                        {!!cmsData?.oldPriceAfterPrice &&
                            <span className={"old-price-after"}>{cmsData?.oldPriceAfterPrice}</span>
                        }
                    </div>
                }
                <div className={"current-price-wrapper"}>
                    <span className={"before-price"}>{cmsData?.beforePrice}</span>
                    <span className={"after-price"}>{cmsData?.afterPrice}</span>
                </div>
            </div>
        </div>
    </>
}